import { render } from "./notifyPopup.vue?vue&type=template&id=6ef9c412"
import script from "./notifyPopup.vue?vue&type=script&lang=js"
export * from "./notifyPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__